export const BALL_COUNT_URL = process.env.REACT_APP_BALL_SOCKET
export const WALLET_SOCKET_URL = process.env.REACT_APP_WALLET_SOCKET
export const REMAINING_COUNT_SOCKET_URL = process.env.REACT_APP_REMAINING_COUNT
export const PLAYER_FRONTEND_URL = process.env.REACT_APP_PLAYEREND_FRONTEND
export const BINGO_SOCKET_KEY = process.env.BINGO_SECRET_KEY
export const REACT_APP_USER_API_URL = process.env.REACT_APP_USER_API_URL
export const BALL_ANIMATION_TIMER = process.env.REACT_APP_BALL_ANIMATION_TIMER
export const ZEGO_APP_ID = process.env.REACT_APP_ZEGO_APP_ID
export const ZEGO_SERVER_URL = process.env.REACT_APP_ZEGO_SERVER_URL
export const REACT_APP_ADMIN_URL = process.env.REACT_APP_ADMIN_URL